<template>
    <div class="d-flex flex-column gap-3">
        <Card v-if="subscription" slim-content>
            <div class="d-flex flex-row">
                <div class="flex-grow-1">
                    <Productable :productable="subscription.subscribable"/>
                </div>
                <div>
                    <Link as="a" class="btn btn-outline-secondary btn-hover-primary" :href="$route('subscriptions.show', {id: subscription.id})">
                        <i class="fas fa-edit" />
                        Verwalten
                    </Link>
                </div>
            </div>
        </Card>
        <Card v-else>
            <a :href="$route('account-setup.show')">create subscription to continue</a>
        </Card>

        <div v-if="subscription" class="row">
            <div v-if="!hasPaymentsConfigured" class="col-6">
                <Card type="danger">
                    <template v-slot:title>Payments</template>
                    Add default payment method
                </Card>
            </div>
            <div class="col-6">
                <Card type="info">
                    <template v-slot:title>Addons</template>
                    Ich möchte weitere addons buchen
                </Card>
            </div>
        </div>

        <Card v-if="false">
            <template v-slot:title>{{ __('general.subscriptions') }}</template>
            <template v-slot:description>{{ __('subscriptions.view_description') }}</template>

            <div class="table-responsive">
                <table class="table table-vertical-center table-hover">
                    <thead>
                    <tr>
                        <th>{{ __('subscriptions.booking') }}</th>
                        <th class="text-center">{{ __('general.status') }}</th>
                        <!--                    <th class="text-center">{{ __('general.stores') }}</th>-->
                        <th class="text-center">{{ __('subscriptions.invoices') }}</th>
                        <th class="text-right">{{ __('general.created') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="sub in paginatedSubscriptions.data">
                        <td>
                            Bundle: {{ sub.subscribable.lang.name }}
                        </td>
                        <td class="text-center">
                            <ResponsiveSubscriptionStatus :subscription="sub"/>
                        </td>
                        <!--                    <td class="text-center">-->
                        <!--                        {{ sub.stores_count }}-->
                        <!--                        <span class="font-weight-light mx-1">{{ __('general.of') }}</span>-->
                        <!--                        {{ sub.paid_stores_count }}-->
                        <!--                    </td>-->
                        <td class="text-center">
                            <CustomerInvoicesLink :total="sub.customer.invoices_count"/>
                        </td>
                        <td class="text-right">
                            <DateResponsive :date="sub.created_at"/>
                        </td>
                        <td class="text-right">
                            <Link as="a" class="btn btn-xs px-4 btn-default btn-hover-primary"
                                  :href="$route('subscriptions.show', sub.id)"
                            >
                                <i class="fas fa-eye ml-1"/>
                            </Link>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <Pagination class="mb-3"
                            :pagination="paginatedSubscriptions"
                            :inertia-options="{only: ['paginatedSubscriptions']}"
                            disable-when-one-page
                />
            </div>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import UserLink from "@components/User/UserLink.vue";
import DateResponsive from "@components/DateResponsive.vue";
import Dot from "@components/Dot.vue";
import Badge from "@components/Badge.vue";
import Pagination from "@components/TableComponents/Pagination.vue";
import ResponsiveSubscriptionStatus from "@components/Subscriptions/ResponsiveSubscriptionStatus.vue";
import CustomerInvoicesLink from "@components/Subscriptions/CustomerInvoicesLink.vue";
import { Link } from '@inertiajs/vue2';
import Productable from "@components/Subscriptions/Productable.vue";

export default {
    components: {
        Productable,
        CustomerInvoicesLink, ResponsiveSubscriptionStatus, Pagination, Badge, Dot, DateResponsive, UserLink, Card, Link
    },

    props: {
        subscription: Object,
        paginatedSubscriptions: Object,
        hasPaymentsConfigured: Boolean
    }
}
</script>
